import { Action } from 'redux';

import { ReducerFns } from '../insight/insight.reducer';

import {
    ActionType,
    LevelOptionSelectAction,
    LevelOptionSelectResultAction,
} from './performance-insight.action';
import { defaultState, RootState } from './performance-insight.state';

const levelOptionFns: ReducerFns<RootState, ActionType> = {
    [ActionType.PERFORMANCE_INSIGHT__LEVEL_OPTION__SELECT](
        state,
        action: LevelOptionSelectAction,
    ): RootState {
        return {
            ...state,
            levelOpt: {
                ...state.levelOpt,
                pending: true,
                quickSwitch: undefined,
                active: undefined,
            },
        };
    },
    [ActionType.PERFORMANCE_INSIGHT__LEVEL_OPTION__SELECT_RESULT](
        state,
        action: LevelOptionSelectResultAction,
    ): RootState {
        return {
            ...state,
            levelOpt: {
                ...state.levelOpt,
                pending: false,
                quickSwitch: action.quickSwitch,
                filteredItems: action.filteredItems,
                active: action.opt,
                canChangeActive: action.canChangeActive,
            },
        };
    },
};

const reducerFns: ReducerFns<any, any> = {
    ...levelOptionFns,
};

const performanceInsight = (
    state: RootState = defaultState(),
    action: Action<ActionType>,
): RootState => {
    const fn = reducerFns[action.type];
    if (fn) {
        return fn(state, action);
    }
    return state;
};

export default {
    performanceInsight,
};
